import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const QuizIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf04c'}</MuiIcon>
    );
}
